<template>
  <a-drawer width="45%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="merchantName" >
        <span slot="label" >
          <a-tooltip>
            商家名称<template slot="title">商家名称</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.merchantName" :maxLength="255" :placeholder="$t('请输入')+'商家名称'" />
      </a-form-model-item>
      <a-form-model-item prop="merchantLogo" >
        <span slot="label" >
          <a-tooltip>
            商家logo<template slot="title">商家logo</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.merchantLogo" prefix="merchant" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="merchantBackground" >
        <span slot="label" >
          <a-tooltip>
            商家背景图<template slot="title">商家背景图</template>
          </a-tooltip>
        </span>
        <oss-upload-single v-model="form.merchantBackground" prefix="merchant" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="merchantAreax" >
        <span slot="label" >
          <a-tooltip>
            商家所在地<template slot="title">商家所在地</template>
          </a-tooltip>
        </span>
        <a-cascader :options="areaList"
                    :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                    :placeholder="$t('请选择')+'商家所在地'"
                    style="width: 100%" v-model="areaSelected" allowClear @change="onAreaChange">
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item prop="merchantAddress" >
        <span slot="label" >
          <a-tooltip>
            详细地区<template slot="title">详细地区</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.merchantAddress" :maxLength="255" :placeholder="$t('请输入')+'详细地区'" />
      </a-form-model-item>

      <a-form-model-item prop="businessType" >
        <span slot="label" >
          <a-tooltip>
            经营类型<template slot="title">店铺类型 1:自营 2:入驻</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.businessType" :disabled="userInfo.deptType===2" :placeholder="$t('请输入')+'经营类型'" >
          <a-select-option v-for="(item, index) in customDict.BusinessTypeEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="industryId" >
        <span slot="label" >
          <a-tooltip>
            主营行业<template slot="title">主营行业id</template>
          </a-tooltip>
        </span>
        <a-cascader :options="industryList"
                    :field-names="{ label: 'categoryName', value: 'id', children: 'children'}"
                    :placeholder="$t('请选择')+'主营行业'"
                    style="width: 100%" v-model="industrySelected" allowClear @change="onIndustryChange">
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item prop="timeOfEntry" >
        <span slot="label" >
          <a-tooltip>
            入驻时长<template slot="title">入驻时长</template>
          </a-tooltip>
        </span>
        <a-select v-model="form.timeOfEntry" :placeholder="$t('请输入')+'入驻时长'" >
          <a-select-option v-for="(item, index) in this.timeEntryList" :value="item.id" :key="index">
            {{ item.duration }}年
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="customerServiceMobile" >
        <span slot="label" >
          <a-tooltip>
            客服电话<template slot="title">客服电话</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.customerServiceMobile" :maxLength="32" :placeholder="$t('请输入')+'客服电话'" />
      </a-form-model-item>
      <a-form-model-item prop="merchantDescription" >
        <span slot="label" >
          <a-tooltip>
            商家简介<template slot="title">商家简介</template>
          </a-tooltip>
        </span>
        <Editor v-model="form.merchantDescription" style="height: 600px" :placeholder="$t('请输入')"  allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMerchantMerchant, addMerchantMerchant, updateMerchantMerchant } from '@/api/merchant/merchantMerchant'
import { listIndustry } from '@/api/merchant/industry'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import {areaListTree} from "@/api/logistics";
import {listEntry} from "@/api/merchant/entry";
import Editor from "@/components/Editor/Editor.vue";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor,
    OssUploadSingle,
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      areaList: [],
      areaSelected: [],
      timeEntryList: [],
      industryList: [],
      industrySelected: [],
      // 表单参数
      form: {
        id: null,
        merchantName: null,
        merchantLogo: null,
        merchantBackground: null,
        merchantAreax: null,
        merchantAddress: null,
        merchantStatus: 0,
        merchantDescription: null,
        businessType: null,
        longitude: null,
        latitude: null,
        marginAmount: null,
        industryId: null,
        industryParentId:null,
        timeOfEntry: null,
        customerServiceMobile: null,
        imgDetail: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        merchantName: [
          { required: true, message: '商家名称'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantLogo: [
          { required: true, message: '商家logo'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantBackground: [
          { required: true, message: '商家背景图'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantAddress: [
          { required: true, message: '详细地区'+this.$t('不能为空'), trigger: 'blur' }
        ],
        merchantStatus: [
          { required: true, message: '商家状态'+this.$t('不能为空'), trigger: 'blur' }
        ],
        businessType: [
          { required: true, message: '经营类型'+this.$t('不能为空'), trigger: 'change' }
        ],
        merchantAreax: [
          { required: true, message: '商家所在地 '+this.$t('不能为空'), trigger: 'change' }
        ],
        industryId: [
          { required: true, message: '主营行业id'+this.$t('不能为空'), trigger: 'blur' }
        ],
        timeOfEntry: [
          { required: true, message: '入驻时长,外键'+this.$t('不能为空'), trigger: 'blur' }
        ],
        customerServiceMobile: [
          { required: true, message: '客服电话'+this.$t('不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getAreaTree()
    this.getTimeEntry()
  },
  computed: {
    ...mapGetters(['customDict','userInfo'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        merchantName: null,
        merchantLogo: null,
        merchantBackground: null,
        merchantAreax: null,
        merchantAddress: null,
        merchantStatus: 0,
        merchantDescription: null,
        businessType: null,
        longitude: null,
        latitude: null,
        marginAmount: null,
        industryId: null,
        industryParentId:null,
        timeOfEntry: null,
        customerServiceMobile: null,
        imgDetail: null,
        createTime: null,
        remark: null,
        localeFieldMap: {},
      }

    },
    getAreaTree() {
      areaListTree().then(response => {
        this.areaList = response.data
      })
    },
    onAreaChange(value, selectedOptions) {
      this.form.merchantAreax = value[2]
      console.log('onAreaChange',this.form.merchantAreax)
    },
    onIndustryChange(value, selectedOptions) {
      this.form.industryId = value[1]
      console.log('onIndustryChange',this.form.industryId)
    },
    getTimeEntry() {
      listEntry({}).then(response => {
        this.timeEntryList = response.data
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMerchantMerchant({"id":id}).then(response => {
        this.form = response.data
        this.areaSelected.push(this.form.merchantAreax.substring(0, 2) + '0000');
        this.areaSelected.push(this.form.merchantAreax.substring(0, 4) + '00');
        this.areaSelected.push(this.form.merchantAreax);
        this.industrySelected.push(this.form.industryParentId);
        this.industrySelected.push(this.form.industryId);
        this.open = true
        this.formTitle = this.$t('修改')
        this.getIndustryList(this.form.merchantType)
      })
    },
    getIndustryList(merchantType) {
      listIndustry({merchantType:merchantType}).then(response => {
        this.industryList = response.data
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateMerchantMerchant(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3);
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addMerchantMerchant(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
::v-deep .adaptive { height: auto; }
::v-deep .editor .w-e-text-container { height: 300px !important; }
</style>
